import {
  ALERTS,
  USER,
  USER_FULL_NAME,
  ACCESS_GROUPS,
  MENU,
  IS_APP_JS_LOADED,
  DASHBOARD_STATISTICS,
  CLIENT_USER_INACTIVE_TIMEOUT_IN_MINUTES,
  IS_APP_LOADING,
  SET_PAGE,
  SET_CRAR_DATA,
  CRAR_DATA,
  PAGE,
  IS_ALLOWED
} from './definition'

const pagesDoNotShowOnMenu = {
  'SOURCING_WF': {
    'SERVICE_REQUEST': {
      'DETAIL': ['ADMINISTRATOR', 'APPROVER', 'CREATOR', 'EDITOR', 'VIEWER'],
      'CREATE': ['ADMINISTRATOR', 'APPROVER', 'EDITOR', 'VIEWER']
    }
  }
}

/**
 * SMS ACCESS GROUPS
 * @type {Array}
 */
const sag = [
  'SMS_ADMIN', // 0
  'SMS_HELPDESK', // 1
  'SMS_BRAND_AD_GEN', // 2
  'SMS_BRAND_AD_REVIEW', // 3
  'SMS_AD_RECEIVER', // 4
  'SMS_BRAND_DEV_SAMPLE', // 5
  'SMS_GIS_AD', // 6
  'SMS_GIS_DEV_SAMPLE', // 7
  'SMS_GIS_SMR', // 8
  'SMS_VENDOR_AD', // 9
  'SMS_VENDOR_DEV_SAMPLE', // 10
  'SMS_VENDOR_SMR', // 11
  'SMS_BRAND_SMR', // 12
  'SMS_GIS_COCREATION', // 13
  'SMS_VENDOR_COCREATION', // 14
  'SMS_BRAND_COCREATION', // 15
  'SMS_BRAND_TOP', // 16
  'SMS_GIS_TOP', // 17
  'SMS_VENDOR_TOP', // 18
  'TRIM_SUPPLIER' // 19
]

/**
 * Allowed user's functions base on they access group
 * @type {Object}
 */
const accessGroupLimited = {
  'initiate-ad-sample-requests': {
    'create': [sag[0], sag[2]]
  },
  'initiate-top-sample-requests': {
    'create': [sag[0], sag[16]]
  },
  'review-ad-sample-requests': {
    'brandDrop': [sag[0], sag[1], sag[2], sag[16]],
    'vendorReject': [sag[0], sag[1], sag[9], sag[18]],
    'massUpdateBrandSampleDueDate': [sag[0], sag[1], sag[9], sag[16]],
    'massUpdateBrand': [sag[0], sag[1], sag[2], sag[6], sag[16], sag[17]],
    'massUpdateBrandSize': [sag[0], sag[1], sag[2], sag[16]],
    'massUpdateBrandQty': [sag[0], sag[1], sag[2], sag[16]],
    'massUpdateBrandShipTo': [sag[0], sag[1], sag[2], sag[16]],
    'massUpdateBrandComment': [sag[0], sag[1], sag[2], sag[6], sag[16], sag[17]],
    'massUpdateBorrowAndHandOff': [sag[0], sag[1], sag[2]],
    'massUpdateBrandIsPriority': [sag[0], sag[1], sag[2], sag[16]],
    'massUpdateAmendmentReason': [sag[0], sag[1], sag[2], sag[16]],
    'massUpdateVender': [sag[0], sag[8], sag[9], sag[10], sag[11], sag[18]],
    'massUpdateVenderDate': [sag[0], sag[9], sag[18]],
    'massUpdateVenderLate': [sag[0], sag[9], sag[18]],
    'massUpdateVenderComment': [sag[0], sag[8], sag[9], sag[10], sag[11], sag[18]],
    'photoUpload': [sag[0], sag[2], sag[9], sag[16], sag[18]],
    'reportExport': [sag[0], sag[1], sag[2], sag[3], sag[4], sag[6], sag[9], sag[16], sag[17], sag[18]],
    'comment': [sag[0], sag[2], sag[6], sag[9], sag[16], sag[17], sag[18]],
    'reorder': [sag[0], sag[1], sag[2], sag[16]],
    'printQrCode': [sag[0], sag[2], sag[3], sag[1], sag[9], sag[16], sag[18]],
    'printPackingList': [sag[0], sag[1], sag[9], sag[18]],
    'create': [sag[0], sag[1], sag[2], sag[6], sag[7], sag[8], sag[9], sag[16], sag[17], sag[18]],
    'addSize': [sag[0], sag[1], sag[2], sag[16]],
    'getVendorFilter': [sag[0], sag[1], sag[2], sag[3], sag[4], sag[5], sag[6], sag[7], sag[8], sag[12], sag[16], sag[17]],
    'shipmentReport': [sag[0], sag[1], sag[2], sag[3], sag[4], sag[5], sag[12], sag[13], sag[14], sag[15], sag[16]]
  },
  'shipment-report': {
    'getVendorFilter': [sag[0], sag[1], sag[2], sag[3], sag[4], sag[5], sag[6], sag[7], sag[8], sag[12]]
  },
  'update-ad-sample-matrix': {
    'block-downloadTemplate': [sag[2], sag[3], sag[4], sag[6], sag[9], sag[16], sag[17], sag[18]],
    'create': [sag[0], sag[2], sag[16]]
  },
  'review-dev-sample-requests': {
    'create': [sag[0]],
    'exportAll': [sag[0]],
    'reportExport': [sag[0], sag[5], sag[7], sag[10]],
    'massUpdateBrand': [sag[0], sag[1], sag[2], sag[6]],
    'massUpdateVender': [sag[0], sag[7], sag[10]],
    'photoUpload': [sag[0], sag[10]],
    'comment': [sag[0], sag[5], sag[7], sag[10]],
    'printQrCode': [sag[0], sag[1], sag[10]],
    'printPackingList': [sag[0], sag[1], sag[5], sag[7], sag[10]],
    'search': [sag[0], sag[1], sag[2], sag[3], sag[4], sag[5], sag[6], sag[7], sag[9], sag[10], sag[13], sag[14]],
    'getVendorFilter': [sag[0], sag[1], sag[2], sag[3], sag[4], sag[5], sag[6], sag[7], sag[8], sag[12]],
    'viewRelatedSMR': [sag[0], sag[1], sag[5], sag[7], sag[8], sag[10], sag[11], sag[12]]
  },
  'review-smr': {
    'view': [sag[0], sag[1], sag[5], sag[7], sag[8], sag[10], sag[11], sag[12], sag[19]],
    'search': [sag[0], sag[1], sag[5], sag[7], sag[8], sag[11], sag[12], sag[19]],
    'massUpdateFlag': [sag[0], sag[8], sag[11], sag[19]],
    'massUpdate': [sag[0], sag[8], sag[11], sag[19]],
    'viewRelatedDev': [sag[0], sag[1], sag[5], sag[7], sag[8], sag[10], sag[11], sag[12], sag[19]],
    'commentRead': [sag[0], sag[1], sag[5], sag[7], sag[8], sag[11], sag[12], sag[19]],
    'commentWrite': [sag[0], sag[8], sag[11], sag[12], sag[19]],
    'photoUpload': [sag[0], sag[8], sag[11], sag[19]]
  },
  'manual-shipment': {
    'ad-shipment': [sag[0], sag[1], sag[2], sag[3], sag[6], sag[9]],
    'dev-shipment': [sag[0], sag[1], sag[5], sag[7], sag[10]],
    'smr-read': [sag[0], sag[1], sag[2], sag[3], sag[8], sag[11], sag[19]],
    'smr-write': [sag[0], sag[1], sag[8], sag[11], sag[19]],
    'modify': [sag[0], sag[1], sag[6], sag[7], sag[8], sag[9], sag[10], sag[11], sag[19]],
    'create': [sag[0], sag[1], sag[6], sag[7], sag[8], sag[9], sag[10], sag[11], sag[19]]
  },
  'update-shipment': {
    'ad-shipment': [sag[0], sag[1], sag[2], sag[3], sag[4], sag[6], sag[9]],
    'top-shipment': [sag[0], sag[1], sag[16], sag[17], sag[18]],
    'dev-shipment': [sag[0], sag[1], sag[5], sag[7], sag[10]],
    'smr-read': [sag[0], sag[1], sag[2], sag[3], sag[8], sag[11], sag[12], sag[19]],
    'smr-write': [sag[0], sag[1], sag[8], sag[11], sag[19]],
    'smr-edit': [sag[0], sag[1], sag[8], sag[11], sag[19]],
    'create': [sag[0], sag[1], sag[6], sag[7], sag[8], sag[9], sag[10], sag[11], sag[17], sag[18], sag[19]],
    'scan-and-pack': [sag[0], sag[1], sag[9]]
  },
  'search-shipment': {
    'ad-shipment': [sag[0], sag[1], sag[2], sag[3], sag[6], sag[9]],
    'top-shipment': [sag[0], sag[1], sag[16], sag[17], sag[18]],
    'dev-shipment': [sag[0], sag[1], sag[5], sag[7], sag[10]],
    'smr-shipment': [sag[0], sag[1], sag[2], sag[3], sag[8], sag[11], sag[12], sag[19]],
    'smr-bypass': [sag[0], sag[1], sag[8], sag[12]],
    'scan-and-pack': [sag[0], sag[1], sag[9]]
  },
  'update-package': {
    'ad-shipment': [sag[0], sag[1], sag[2], sag[3], sag[4], sag[6], sag[9]],
    'top-shipment': [sag[0], sag[1], sag[16], sag[17], sag[18]],
    'dev-shipment': [sag[0], sag[1], sag[5], sag[7], sag[10]],
    'smr-read': [sag[0], sag[1], sag[2], sag[3], sag[8], sag[11], sag[12], sag[19]],
    'create': [sag[0], sag[1], sag[9]]
  },
  'generate-summary-reports': {
    'create': [sag[0], sag[1], sag[2], sag[3], sag[4], sag[6], sag[9]]
  },
  'receive-shipment': {
    'create': [sag[0], sag[1], sag[2], sag[4], sag[5], sag[6], sag[16], sag[17]],
    'confirmReceiveAndReorder': [sag[0], sag[2], sag[3], sag[4], sag[16]]
  },
  'co-creation': {
    'view': [sag[0], sag[13], sag[14], sag[15]],
    'createFabric': [sag[0], sag[13], sag[14]],
    'createProduct': [sag[0], sag[13], sag[14]],
    'createCatalog': [sag[0], sag[13], sag[14]],
    'batchUpload': [sag[0], sag[13], sag[14]],
    'photoUpload': [sag[0], sag[13], sag[14]],
    'downloadTemplate': [sag[0], sag[13], sag[14]],
    'downloadReport': [sag[0], sag[14], sag[15]],
    'cardPrinting': [sag[0], sag[14], sag[15]],
    'massUpdateBrand': [sag[0], sag[15]],
    'massUpdateVendor': [sag[0], sag[13], sag[14]],
    'vendor': [sag[14]],
    'addToCatalog': [sag[0], sag[13], sag[14]]
  },
  'configure-courier': {
    'view': [sag[0]],
    'create': [sag[0]]
  },
  'purpose-config': {
    'create': [sag[0]]
  },
  'searchfilterconfig': {
    'create': [sag[0]]
  },
  'configuration': {
    'view': [sag[0], sag[1]],
    'purposeConfig': [sag[0]],
    'create': [sag[0]],
    'createPurposeMarketMapping': [sag[0]],
    'createAdReorderReason': [sag[0]],
    'createAdReorderDateConfig': [sag[0]],
    'createautoInitAdConfig': [sag[0]],
    'createGracePeriodMaster': [sag[0]],
    'createSamplePurposeMaster': [sag[0]],
    'createBrandAndSeason': [sag[0]],
    'adSprAttConfig': [sag[0]],
    'lcSprAttConfig': [sag[0]],
    'shipmentConfig': [sag[0], sag[1]],
    'updateShipment': [sag[0]],
    'updateCourierShipmentStatus': [sag[0]],
    'viewClearCourier': [sag[0], sag[1]],
    'clearADCourier': [sag[0]],
    'updateException': [sag[0]]
  }
}

const shouldShowPageOnMenu = (accessModel) => {
  let {
    accessModule,
    accessFunction,
    accessPage,
    accessRole
  } = accessModel
  return !pagesDoNotShowOnMenu[accessModule] ||
          !pagesDoNotShowOnMenu[accessModule][accessFunction] ||
          !pagesDoNotShowOnMenu[accessModule][accessFunction][accessPage] ||
          pagesDoNotShowOnMenu[accessModule][accessFunction][accessPage].indexOf(accessRole) === -1
}

const checkUserRight = (user, fn, page) => {
  for (let i = 0; i < user.accessGroupList.length; i++) {
    if (accessGroupLimited && accessGroupLimited[page] && accessGroupLimited[page][fn] && accessGroupLimited[page][fn].includes(user.accessGroupList[i].accessGroup)) {
      return true
    }
  }
  return false
}
const generateMenu = function (user) {
  if (!user) {
    return []
  }

  const path = str => '/' + str.toLowerCase().replace('_', '-')

  const sortByName = (a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0

  const generateURL = (accessModel) => {
    let {
      accessModule,
      accessFunction,
      accessPage,
      accessPageURL
    } = accessModel
    return accessPageURL || path(accessModule) + path(accessFunction) + path(accessPage)
  }

  const accessGroups = user.accessGroupList
  const accessModels = accessGroups.reduce((list, accessGroup) => {
    list.push(...accessGroup.accessModelList)
    return list
  }, [])

  const modules = [...accessModels.filter(accessModel => {
    return shouldShowPageOnMenu(accessModel)
  }).reduce((map, accessModel, accessModelIndex) => {
    let {
      accessModule,
      accessFunction,
      accessPage,
      accessRole,
      accessPermission
    } = accessModel

    if (!accessModule || !accessFunction || !accessPage) {
      return map
    }

    let moduleItem
    let functionItem

    if (!map.has(accessModule)) {
      map.set(accessModule, {
        id: accessModule,
        name: accessModel.accessModuleDescription,
        functionMap: new Map()
      })
    }
    moduleItem = map.get(accessModule)
    if (!moduleItem.functionMap.has(accessFunction)) {
      moduleItem.functionMap.set(accessFunction, {
        id: accessFunction,
        name: accessModel.accessFunctionDescription,
        pageMap: new Map()
      })
    }
    functionItem = moduleItem.functionMap.get(accessFunction)
    functionItem.pageMap.set(accessPage, {
      id: accessPage,
      name: accessModel.accessPageDescription,
      order: accessModelIndex,
      accessRole,
      accessPermission,
      url: generateURL(accessModel)
    })
    return map
  }, new Map())].map(pair => pair[1]).sort(sortByName)
  modules.forEach(module => {
    module.functionList = [...module.functionMap].map(pair => pair[1]).sort(sortByName)
    module.functionList.forEach(functionItem => {
      functionItem.pageList = [...functionItem.pageMap].map(pair => pair[1]).sort((a, b) => a.order - b.order)
    })
  })

  return modules
}

const banners = (state) => {
  return state.banners
}

export default {
  banners,
  [ALERTS] (state) {
    return state.alerts
  },
  [USER] (state) {
    return state.user
  },
  [USER_FULL_NAME] (state, getters) {
    return getters[USER] ? getters[USER].firstName + ' ' + getters[USER].lastName : ''
  },
  [ACCESS_GROUPS] (state, getters) {
    return getters[USER].accessGroupList
  },
  [MENU] (state, getters) {
    return generateMenu(getters[USER])
  },
  [IS_APP_JS_LOADED] (state, getters) {
    return state.isAppJsLoaded
  },
  [DASHBOARD_STATISTICS] (state, getters) {
    return state.dashboardStatistics
  },
  [CLIENT_USER_INACTIVE_TIMEOUT_IN_MINUTES] (state, getters) {
    return state.clientUserInactiveTimeoutInMinutes
  },
  [IS_APP_LOADING] (state, getters) {
    return state.isAppLoading
  },
  [SET_CRAR_DATA]: (state, getters) => fn => {
    getters[CRAR_DATA] = fn
  },
  [SET_PAGE]: (state, getters) => fn => {
    getters[PAGE] = fn
  },
  [IS_ALLOWED]: (state, getters) => (fn) => {
    return checkUserRight(getters[USER], fn, getters[PAGE])
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js